module.exports = __webpack_public_path__ + "static/RUmobSlide1-c12685523459b962200c639b0cf957c4.jpg";